import React, { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/gmao";
import { Btn, Field, Modal } from "./Shared";
import { Eye, EyeSlash } from "@phosphor-icons/react";

function PasswordInput({ value, onChange, testid, autoComplete }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input type={show ? "text" : "password"} value={value} onChange={onChange} autoComplete={autoComplete} data-testid={testid}
        className="w-full px-3 py-2 pr-10 bg-white border border-slate-300 rounded-sm text-sm text-slate-900 outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600 transition-all" />
      <button type="button" tabIndex={-1} onClick={() => setShow((s) => !s)} data-testid={`${testid}-toggle`}
        aria-label={show ? "Ocultar contraseña" : "Mostrar contraseña"}
        className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700">
        {show ? <EyeSlash size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
}

export function ChangePasswordModal({ open, onClose }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);
  const close = () => { setCurrent(""); setNext(""); setConfirm(""); setError(null); onClose(); };
  const submit = async (e) => {
    e.preventDefault();
    if (!current || !next || !confirm) { setError("Todos los campos son obligatorios."); return; }
    if (next.length < 8) { setError("La nueva contraseña debe tener al menos 8 caracteres."); return; }
    if (next !== confirm) { setError("La nueva contraseña y su confirmación no coinciden."); return; }
    if (next === current) { setError("La nueva contraseña no puede ser igual a la actual."); return; }
    setError(null); setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Contraseña actualizada. Tu sesión sigue abierta; las sesiones en otros dispositivos se han cerrado.");
      close();
    } catch (err) {
      setError(formatApiErrorDetail(err?.response?.data?.detail) || "No se pudo cambiar la contraseña.");
    } finally { setSaving(false); }
  };
  return (
    <Modal open={open} onClose={close} title="Cambiar contraseña">
      <form onSubmit={submit} className="space-y-4" data-testid="change-password-form">
        <p className="text-sm text-slate-500">Cambia la contraseña de tu cuenta. Solo afecta a tu propio usuario.</p>
        <Field label="Contraseña actual">
          <PasswordInput value={current} onChange={(e) => setCurrent(e.target.value)} testid="current-password-input" autoComplete="current-password" />
        </Field>
        <Field label="Nueva contraseña (mínimo 8 caracteres)">
          <PasswordInput value={next} onChange={(e) => setNext(e.target.value)} testid="new-password-input" autoComplete="new-password" />
        </Field>
        <Field label="Confirmar nueva contraseña">
          <PasswordInput value={confirm} onChange={(e) => setConfirm(e.target.value)} testid="confirm-password-input" autoComplete="new-password" />
        </Field>
        {error && <p className="text-sm text-red-600" data-testid="change-password-error">{error}</p>}
        <div className="flex justify-end gap-2">
          <Btn variant="secondary" type="button" onClick={close} data-testid="change-password-cancel">Cancelar</Btn>
          <Btn type="submit" disabled={saving} data-testid="change-password-save">{saving ? "Guardando…" : "Guardar nueva contraseña"}</Btn>
        </div>
      </form>
    </Modal>
  );
}
